export let ocvFeedbackPanelLabel = "rzUHSc";
export default {ocvFeedbackPanelLabel};